import ToastContext from './ToastContext';
import ToastProvider from './ToastProvider';

export default {
  Consumer: ToastContext.Consumer,
  Provider: ToastProvider
};
